<template>
  <div>
    <div class="fullwidth nobp">
      <div class="flex-start">
        <div style="flex-grow:2">
          <div class="exclusive">{{$nippets.exrep}}</div>
          <h1 class="pf-h1">{{ artist.formatted_name }}</h1>
        </div>
        <search-widget right v-if="!mobile" />
      </div>
      <div class="flex-portfolio">
        <div class="pf-one-div">
          <portfolio-intro :artist="artist" v-on:changeRegion="changeRegion" v-on:load="loadedDetails" />
          <column-handler :images="extraColumn" :artist="artist" 
            :dists="dists" :maxheight="maxheight" :fullyLoaded="fullyLoaded" 
            v-on:click="handleZoom"
            v-on:loaded="handleLoadedColumn" ></column-handler>
          
        </div>
        <div class="pf-rest-div">
          <portfolio-controls :artist="artist" :details="details" :mobile="mwidth < 1100" />
          <div class="pf-matrix">
            <column-handler v-for="(col, index) in imageColumns" :key="index" :artist="artist" :images="col" 
              :dists="dists" :maxheight="maxheight" :fullyLoaded="fullyLoaded" 
              v-on:click="handleZoom" v-on:loaded="handleLoadedColumn" ></column-handler>
          </div>
        </div>
        <zoom-image :visible="showZoom" 
          v-on:prev="zoomImage(-1)" v-on:next="zoomImage(1)"
          :image="selImage" v-on:close="closeZoom" :artist="artist" />
      </div>
      <div style="text-align:right">
        <top-button />
      </div>
      
    </div>
    <div class="marginal">
      <az-browse-panel :artists="details.related" :title="$nippets.portfolio.related" :artist="artist" />
    </div>
    <testimonial-floater :artist="artist.portfolio_url" />
  </div>
</template>

<script>
import SearchWidget from '@/components/widgets/SearchWidget.vue'
import ZoomImage from '@/components/panels/ZoomImage.vue'
import PortfolioIntro from '@/components/panels/PortfolioIntro.vue'
import PortfolioControls from '@/components/panels/PortfolioControls.vue'
import AzBrowsePanel from '@/components/panels/AzBrowsePanel.vue'
import TopButton from '@/components/buttons/TopButton.vue'
import TestimonialFloater from '@/components/panels/TestimonialFloater.vue'
import ColumnHandler from './portfolio/ColumnHandler.vue'

import '@/css/portfolio.css'
import rsnippets from '@/utils/rich-snippets.js'



export default {
  components: {
    PortfolioIntro,
    SearchWidget,
    ZoomImage,
    PortfolioControls,
    AzBrowsePanel,
    TopButton,
    TestimonialFloater,
    ColumnHandler
  },
  props: {
    name: String,
    nonlive: Boolean
  },
  data: function () {
    return {
      artist: { galleries: [], region: ''},
      details: {},
      images: [],
      imageColumns: [],
      numColumns: 0,
      extraColumn: [],
      showZoom: false,
      selImage: null,
      subhead: '',
      mwidth:1024,
      maxheight: 0,
      dists: [],
      numLoaded: 0
    }
  },
  computed: {
    mobile() {
      return this.mwidth <= 640
    },
    fullyLoaded() {
      return this.numLoaded >= (this.numColumns + 1)
    },
    HOLDBACK() {
      return (2 * this.numColumns) + 1
    }
  },
  mounted: function () {
    this.setUpSizing()
    window.addEventListener('resize', this.setUpSizing)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setUpSizing)
  },
  methods: {
    setMetatags() {
      if(this.details) {
        if(!this.details.meta_title || (this.details.meta_title === 'My Homepage')) {
          this.details.meta_title = 'IllustrationX - ' + this.artist.formatted_name + ' portfolio'
        }
        let rs = rsnippets.getRichSnippet(this.artist, this.details, this.$route.path, this.$nippets)
        let desc = this.details.meta_description
        if(!desc) {
          desc = ''
        }
        console.log('desc', desc)
        this.$k.setMetatags(this.details.meta_title, desc, rs)
      }
      
    },
    hideTestimonials () {
      this.showTestimonials = false
    },
    loadedDetails (details) {
      this.details = details
      
      this.setMetatags()
    },
    setUpSizing: function () {
      this.mwidth = window.innerWidth
      let breakpoint = this.$k.getBreakpoint()
      this.numColumns = breakpoint.columns - 1
    },
    getCurrentPos: function () {
      if(!this.selImage.image_id) return -1
      return this.images.findIndex(el => el.image_id === this.selImage.image_id)
    },
    zoomImage: function (moveRel) {
      let pos = this.getCurrentPos()
      if(pos < 0) {
        pos = 0
      }
      else {
        pos += moveRel
        if(pos < 0) {
          pos = this.images.length - 1
        }
        else if (pos >= this.images.length) {
          pos = 0;
        }
      }
      this.selImage = this.images[pos]
    },
    resetColumns: function () {
      while(this.dists.length > 0) {
        this.dists.pop()
      }
      while(this.imageColumns.length > 0) {
        this.imageColumns.pop()
      }
      while(this.extraColumn.length > 0) {
        this.extraColumn.pop()
      }
    },
    loadData: async function () {
      this.numLoaded = 0
      this.maxheight = 0
      try {
        
        let artist = null
        if(!this.nonlive) {
          artist = await this.$store.dispatch('fetchArtist', this.name)
        }
        else {
          let res = await this.$apix.get(`collections/nonlive-artist/${this.name}`)
          artist = res.data
          
        }
        if(!artist) {
          this.$k.goNotFound()
          return
        }
        if(this.name !== artist.portfolio_url) {
          this.$ixr.push('/artists/' + artist.portfolio_url)
          return
        }
        this.artist = artist
      }
      catch(err) {
        console.log('not got artist', err)
        return
      }
      this.resetColumns()
      this.numLoaded = 0
      this.initialLoadComplete = false
      await this.$store.dispatch('fetchGalleries')
      if(!this.nonlive){
        this.$store.commit('addRecent', this.artist.portfolio_url)
      }
      
      let res = this.$store.state.artistImages[this.artist.artist_id]
      
      if(!res) {
        res = await this.$apix.post('collections/images', { artist_id: Number(this.artist.artist_id) })
        if(this.artist.animation) {
          res = res.data.filter(el => !el.animation)
        }
        else {
          res = res.data.filter(el => el.image_id)
        }
        res.sort((el, el1) => { return el.order - el1.order})
        
        if(this.artist.max_images > 500) {
          console.log('confirm: unl')
        }
        else {
          res = res.slice(0,120)
        }
        
        this.$store.commit('setArtistImages', { id: this.artist.artist_id, data: res })
      }
      this.images = res
      this.numLoaded = 0
      //layout from here down
      try {
        for(let i = 0; i < this.numColumns; i++) {
          this.imageColumns.push([])
        }
        
        let ctr = 0
        // this is how many pics we will put in the extra column
        this.ecpics = (this.images.length - (8 * this.numColumns)) / (this.numColumns + 1)
        
        
        if(this.numColumns == 1) this.ecpics = this.images.length / 4
        if(this.ecpics < 0) {
          this.ecpics = 0
        }
        this.ecpics += this.HOLDBACK
        while(ctr < this.images.length - this.ecpics ) {
          this.imageColumns[ ctr % this.numColumns ].push(this.images[ctr])
          ctr++
        }
        let max = ctr + this.ecpics
        if(max > this.images.length) {
          max = this.images.length
        }
        max -= this.HOLDBACK
        while(ctr < max) {
          this.extraColumn.push(this.images[ctr])
          ctr++;
        }
        /*
        while(ctr < this.images.length) {
          this.imageColumns[ ctr % this.numColumns ].push(this.images[ctr])
          ctr++
        }*/
        while(ctr < this.images.length) {
          this.dists.push(this.images[ctr])
          ctr++
        }
      }
      catch(err) {
        console.log('error in layout', err)
      }
      
    },
    changeRegion: async function (region) {
      this.$store.commit('setAzLocation', region)
      this.$ixr.push('/artists')
    },
    handleZoom: async function (image) {
      this.selImage = image
      this.showZoom = true
    },
    closeZoom: async function () {
      this.mimage = {}
      this.showZoom = false
    },
    handleLoadedColumn(ht) {
      if(ht > this.maxheight) {
        this.maxheight = ht
      }
      
      this.numLoaded++
    }
  },
  watch: {
    name: function () {
      this.loadData()
    },
    numColumns: function () {
      this.loadData()
    }
  }
}
</script>
<style scoped>
.marginal{
  margin:0;
  background-color:#fff;
  padding:45px;
}

.fullwidth.nobp{
  margin-bottom:0;
}


</style>
